import Avatar, { genConfig } from "react-nice-avatar";

interface NiceAvatarProps {
	name: string;
	width?: string;
	height?: string;
	style?: React.CSSProperties;
}

const NiceAvatar: React.FC<NiceAvatarProps> = ({
	name,
	width = "24px",
	height = "24px",
	style,
}) => {
	const config = genConfig(name);

	return (
		<Avatar
			style={{ width, height, ...style }}
			{...config}
			hairStyle="normal"
			shirtStyle="polo"
		/>
	);
};

export default NiceAvatar;
